export interface FaqItem {
  q: string;
  a: string;
  tag: string;
}

export const FAQS: FaqItem[] = [
  {
    tag: "榜单规则",
    q: "人气韩漫排行榜的排名是怎么来的？",
    a: "榜单综合了作品的读者人气、评分、讨论热度与近期追更数量，并按周榜、月榜和总榜三个维度动态统计。人气榜反映当前讨论与追更热度，高分榜则以读者综合评分为主，帮助你从不同角度挑选作品。",
  },
  {
    tag: "追更方式",
    q: "在哪里可以看到这些韩漫的正版更新？",
    a: "绝大多数热门韩漫都能在各大正版平台看到官方中译连载，如快看、咚漫、Bilibili漫画等。建议优先支持正版，既能第一时间追更，也能让喜欢的作品获得更好的更新支持。",
  },
  {
    tag: "更新状态",
    q: "「连载中」和「已完结」是怎么标注的？",
    a: "标注依据作品当前连载进度：仍在稳定更新的作品标为「连载中」，正文已全部完结的标为「已完结」。部分长期休更或转入第二季的作品会在简介中额外说明，请以平台实际更新为准。",
  },
  {
    tag: "评分标准",
    q: "高分榜的评分可靠吗？",
    a: "评分综合了读者评分、榜单口碑与作品本身的口碑沉淀。高分作品通常意味着较强的剧情、画风与完成度。但每个人口味不同，高分榜更适合作为「优质入门」参考，具体是否合口味仍需亲自试读。",
  },
  {
    tag: "题材分类",
    q: "如何快速找到自己喜欢的题材？",
    a: "你可以在「题材分类」页面按玄幻、冒险、恋爱、恐怖等题材浏览全部作品，也可以通过站内搜索直接输入作品名或关键词。分类与标签会持续更新，帮你更快锁定目标。",
  },
  {
    tag: "追更工具",
    q: "怎样不错过喜欢作品的更新？",
    a: "建议在各正版平台开启作品的「追更/收藏」提醒，同时关注本站在各榜单的更新提示。把心仪作品加入追更列表后，每次更新你都能第一时间收到通知。",
  },
];